import type * as React from 'react';
import { Toaster as SonnerToaster } from 'sonner';

/**
 * The app's toast surface — a preconfigured `sonner` Toaster mounted once in the
 * root route. `richColors` gives success=green / error=red, matching the inline
 * console alerts it replaces; bottom-right + `closeButton` match the v1 design
 * system. Consumers fire toasts through the typed `toast` façade in
 * `@/shared/lib/toast`, never by importing `sonner` directly.
 */
export function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
  return (
    <SonnerToaster
      data-slot="toaster"
      position="bottom-right"
      richColors
      expand={false}
      closeButton
      {...props}
    />
  );
}
